import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"

import Wrapper from "../Wrapper"
import SecondaryDetailsItem from "../Item"

interface Data {
  redemptionUuid?: string,
  orderTotal?: SpendStatementItemTransferOrderTotal
}

interface Props extends InjectIntl {
  className?: string,
  id?: string,
  data: Data
}

class Cashback extends PureComponent<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  render() {
    const {className, data} = this.props
    const {orderTotal} = data
    const idNamespace = id("secondary-details-spend-refund", this.props)

    let orderTotalText
    if (orderTotal) {
      const {value, currency} = orderTotal
      if (value && currency) {
        orderTotalText = (
          <FormattedMessage
            id="wallet.secondaryDetails.spendRefund.orderTotal"
            values={{
              amount: this.props.intl.formatNumber(value, {style: "currency", currency})
            }} />
        )
      }
    }

    return (
      <Wrapper className={className} id={idNamespace}>
        {orderTotalText && <SecondaryDetailsItem isFirstItem text={orderTotalText} />}
      </Wrapper>
    )
  }
}

export default injectIntl(Cashback)
